const EINVOICE_OPERATOR_NAMES: Record<string, string> = {
    '003723327487': 'Apix Messaging',
    '003708599126': 'OpenText',
    '003723609900': 'Pagero',
    NDEAFIHH: 'Nordea',
    OKOYFIHH: 'OP Corporate Bank',
    DABAFIHH: 'Danske Bank',
    HANDFIHH: 'Handelsbanken',
    SBANFIHH: 'S-Pankki',
    POPFFI22: 'POP Pankki',
    AABAFI22: 'Aktia Bank',
    ITELFIHH: 'OpusCapita',
    BAWCFI22: 'Basware',
};

export function getEinvoiceOperatorName(operatorCode: string): string {
    return EINVOICE_OPERATOR_NAMES[operatorCode] ?? operatorCode;
}
